export const GOOGLE_OAUTH_PATH = '/api/oauth-token/v1/authorization/google';
export const GSUITE_OAUTH_PATH = '/api/oauth-token/v1/authorization/googleworkspace';
export const GSUITE_MARKETPLACE_URL = 'https://workspace.google.com/marketplace';
export const MICROSOFT_BUSINESS_OAUTH_PATH = '/api/oauth-token/v1/authorization/microsoftbusiness';
export const MICROSOFT_BUSINESS_CONSENT_PATH = 'https://login.microsoftonline.com/organizations/adminconsent';
